import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { brandGetDetails } from "../redux/actions/brandActions"; 

const useBrandDetails = () => {
  const dispatch = useDispatch();
  const { brandData } = useSelector((state) => state.brand);

  useEffect(() => {
    if (!brandData) {
      dispatch(brandGetDetails());
    }
  }, [brandData, dispatch]);

  const returnBrandDetail = (brandId) => {
    return brandData?.data?.find((brand) => brand?._id === brandId) || null;
  };

  return { brandData, returnBrandDetail };
};

export default useBrandDetails;
